import { isMobile } from "react-device-detect";

const getComponentData = (staticContext, key, other) => {
  let initialData, error, otherData, userBasketData, mobile, serverData;

  if (staticContext && (staticContext.initialData || staticContext[other])) {
    serverData = staticContext.serverData;
    mobile = staticContext.mobile;
    if (staticContext[other]) {
      otherData = staticContext[other];
    }
    if (staticContext.initialData.length) {
      staticContext.initialData.forEach(data => {
        if (data && data.data) {
          if (data.data.hasOwnProperty(key)) {
            initialData = data.data[key];
          } else if (data.data.basket) {
            userBasketData = data.data.basket;
          }
        }

        if (data && data.code) {
          error = data.message;
        }
      });
    }
    if (staticContext.componentData && staticContext.componentData.length) {
      staticContext.componentData.forEach(data => {
        if (data && data.data) {
          if (data.data.hasOwnProperty(key)) {
            initialData = data.data[key];
          }

          if (data.data.hasOwnProperty(other)) {
            otherData = data.data[other];
          } else {
            //initialData[key] = data.data;
          }
        }

        if (data && data.code) {
          error = data.message;
        }
      });
    }
    // eslint-disable-next-line
  } else if (__isBrowser__ && (window.componentData || window[other])) {
    mobile = isMobile;
    if (window[other]) {
      otherData = window[other];
    }
    if (window.componentData.length) {
      window.componentData.forEach(data => {
        if (data && data.data) {
          if (data.data[key]) {
            initialData = data.data[key];
          } else if (data.data.basket) {
            userBasketData = data.data.basket;
          } else if (data.data[other]) {
            otherData = data.data[other];
          } else {
            initialData[key] = data.data;
          }
        }
        delete window.componentData;
        if (data && data.code) {
          error = data.message;
        }
      });
    }
  } else {
    initialData = null;
    otherData = null;
    userBasketData = null;
    error = "Network Error";
    mobile = null;
    serverData = null;
  }

  return {
    error,
    initialData,
    otherData,
    mobile,
    userBasketData,
    serverData
  };
};

export default getComponentData;
